import { useState, useEffect } from "react";
import showErrorToast from "../../components/CustomComponents/toast/toast";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import FormInput from "../../components/CustomComponents/Input/formInput";

function CategoryDepartmentModel({
  isModalOpen,
  setIsModalOpen,
  onDepartmentSubmit,
  compID,
  departmentToEdit = null,
}) {
  const [departmentData, setDepartmentData] = useState({
    cD_Name: "",
  });

  useEffect(() => {
    if (departmentToEdit) {

  

      if (Array.isArray(departmentToEdit)) {
        // For bulk edit, use the first department's name as default
       
        setDepartmentData({
          cD_Name: departmentToEdit[0]?.cD_Name || "",
          cD_ID: departmentToEdit[0]?.cD_ID || 0,
          cD_SortOrder: departmentToEdit[0]?.cD_SortOrder || 0,
        });
      } else {
        // For single edit, populate with department data
        setDepartmentData({
          cD_ID: departmentToEdit.cD_ID,
          cD_Name: departmentToEdit.cD_Name || "",
          cD_SortOrder: departmentToEdit.cD_SortOrder || 0,
        });
      }
    } else {
      // For adding new department
      setDepartmentData({
        cD_Name: "",
        cD_SortOrder: 0,
      });
    }
  }, [departmentToEdit]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setDepartmentData({
      cD_Name: "",
    });
  };

  const handleSubmit = () => {
    try {
      // Validate department name
      if (!departmentData.cD_Name || departmentData.cD_Name.trim().length === 0) {
        showErrorToast("Please provide a valid department name");
        return;
      }

      if (Array.isArray(departmentToEdit)) {
        // Handle bulk edit
        const submitPromises = departmentToEdit.map((dept) => {
          const submitData = {
            cD_ID: dept.cD_ID,
            cD_Name: departmentData.cD_Name,
            cD_SortOrder: departmentData.cD_SortOrder, // Default value since not editable
            compID
          };
          return onDepartmentSubmit(submitData, true);
        });
        Promise.all(submitPromises).then(() => {
          setIsModalOpen(false);
          setDepartmentData({ cD_Name: "" });
        });
      } else {
        // Handle single add/edit
        const submitData = {
          cD_ID: departmentToEdit ? departmentToEdit.cD_ID : 0,
          cD_Name: departmentData.cD_Name,
          cD_SortOrder: departmentData.cD_SortOrder, // Default value since not editable
          compID
        };
        onDepartmentSubmit(submitData, !!departmentToEdit);
        setIsModalOpen(false);
        setDepartmentData({ cD_Name: "" });
      }
    } catch (err) {
      showErrorToast("Something went wrong.");

    }
  }

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      onSubmit={handleSubmit}
      title={
        departmentToEdit
          ? Array.isArray(departmentToEdit)
            ? "Bulk Update Category Departments"
            : "Update Category Department"
          : "Add Category Department"
      }
      showButton={true}
      isCentered={true}
      submitButtonText={departmentToEdit ? "Update" : "Add"}
    >
      <div className="row g-3 mb-4">
        <div className="col-md-12">
          <FormInput
            label="Department Name"
            placeHolder="Enter Department Name"
            type="text"
            value={departmentData.cD_Name}
            onchange={(e) =>
              setDepartmentData({
                ...departmentData,
                cD_Name: e.target.value,
              })
            }
            required
          />
        </div>
      </div>
    </CustomModal>
  );
}

export default CategoryDepartmentModel;